import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";
import { LoadingButton } from "../../components/LoadingButton";

interface DeleteMessageConfirmationBottomSheetProps {
  modalState: UseModalState;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteMessageConfirmationBottomSheet(
  props: DeleteMessageConfirmationBottomSheetProps
) {
  const { modalState, isLoading, onConfirm, onCancel } = props;

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            variant="outlined"
            size="large"
            isLoading={isLoading}
            sx={(theme) => ({
              color: theme.palette.error.main,
              borderColor: theme.palette.error.main,
            })}
            onClick={onConfirm}
          >
            Delete
          </LoadingButton>
          <Button fullWidth variant="outlined" size="large" onClick={onCancel}>
            Cancel
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={onCancel} />}
      modalState={modalState}
    >
      <BottomSheetIllustrationContent
        illustrationType="document-rejected"
        title="Delete message?"
        description="This action cannot be undone."
      />
    </BottomSheet>
  );
}
